import { type FC } from "react";
import { Check } from "lucide-react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

export const SelfProvingConfirmedScreen: FC<FlowCustomComponentProps> = () => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-2">
        <Check className="h-5 w-5 text-brand" />
        <p className="font-sans text-xl font-semibold leading-[30px]">
          No extra witness statements needed
        </p>
      </div>
      <p className="text-sm text-secondary tracking-[-0.28px]">
        Because the back of the will has a notarized Self-Proving Affidavit, New York Surrogate's
        Court accepts the witness signatures as already verified.
      </p>

      <div className="flex flex-col rounded-lg border border-primary overflow-clip bg-white p-6">
        <p className="text-sm font-semibold mb-3">What happens next</p>
        <ul className="flex flex-col gap-3 text-sm text-secondary tracking-[-0.28px]">
          <li>
            <span className="font-semibold text-primary">Skip witness forms:</span> You don't need
            to obtain Form P-3 or reach out to any witnesses listed in the will.
          </li>
          <li>
            <span className="font-semibold text-primary">Ready for your packet:</span> Your probate
            petition will rely directly on the self-proving page already attached to the original
            document.
          </li>
        </ul>
      </div>
    </div>
  );
};
